import { put, takeLatest, call } from 'redux-saga/effects';

import SearchPage from '@interfaces/search-page';

import * as actions from './actions';
import * as types from './types';
import * as service from './service';

function* fetchSearch(action: any) {
    try {
        const data: SearchPage = yield call(service.fetchSearch, action.payload);

        yield put(actions.fetchSearchSuccess(data));
    } catch (error) {
        yield put(actions.fetchSearchError(error.message));
    }
}

export default function* appSaga() {
    yield takeLatest(types.FETCH_SEARCH, fetchSearch);
}
